
import APIClient from './APIClient'

export const Roles = {
  Employee : 0,
  Manager  : 1,
  Admin    : 2
}

class CUsersAPI {

  async getUser(id) {
    const res = await APIClient.GET('/users/'+id)
    return res
  }

  async deleteUser(id) {
    const res = await APIClient.DELETE('/users/'+id)
    return res
  }




  async listAdmins() {
    const res = await APIClient.GET('/users', {role: Roles.Admin})
    return res
  }

  async createAdmin({ name, email, password }) {
    const res = await APIClient.POST('/users', {
      role: Roles.Admin,
      name, 
      email,
      password
    })
    return res
  }

  async updateAdmin(id, { name, email, password }) {
    const payload = {
      name, 
      email,
    }
    if (password) payload.password = password
    const res = await APIClient.POST('/users/'+id, payload)
    return res
  }





  async listManagers() {
    const res = await APIClient.GET('/users', {role: Roles.Manager})
    return res
  }

  async createManager({ name, email, password, division_id }) {
    const res = await APIClient.POST('/users', {
      role: Roles.Manager,
      name, 
      email,
      password,
      division_id
    })
    return res
  }

  async updateManager(id, { name, email, password, division_id }) {
    const payload = {
      name, 
      email,
      division_id
    }
    if (password) payload.password = password
    const res = await APIClient.POST('/users/'+id, payload)
    return res
  }

}

const UsersAPI = new CUsersAPI()

export default UsersAPI



// WEBPACK FOOTER //
// ./src/api/UsersAPI.js